import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@cosmos/angular/utils';
import { catchError, map, Observable } from 'rxjs';
import { ConcreteMixture } from '@cosmos/shared';
import { environment } from '../../../../../../environments/environment';

// export interface ConcreteMixture {
//   _id?: string;
//   name: string;
//   description?: string;
//   concreteType: string;
//   project: string;
//   concreteModels?: string[];
//   activeModelIndex?: number;
//   company?: string[];
//   fck: number;
//   isCertified?: boolean;
//   certificationLevel?: string;
//   certificationDispersionValue?: number;
// }

@Injectable({
  providedIn: 'root'
})
export class ConcreteMixturesService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) { }

  find(query=''): Observable<HttpResponse<ConcreteMixture[]>> {
    return this.http
      .get<ConcreteMixture[]>(`${environment.API_URL}/concrete-mixtures${query}`, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

  findById(id: string): Observable<HttpResponse<ConcreteMixture>> {
    return this.http
      .get<ConcreteMixture>(`${environment.API_URL}/concrete-mixtures/${id}`, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

  create(body: ConcreteMixture) {
    return this.http
      .post(`${environment.API_URL}/concrete-mixtures`, body, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

  update(id: string, body: Partial<ConcreteMixture>) {
    return this.http
      .patch(`${environment.API_URL}/concrete-mixtures/${id}`, body, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

  delete(id: string) {
    return this.http
      .delete(`${environment.API_URL}/concrete-mixtures/${id}`, {observe: 'response'})
        .pipe(
          map(response => {return response;}),
          catchError( (error) =>{this.errorService.handleError(error); throw error;})
        );
  }

}
